module.exports = __webpack_public_path__ + "static/media/login-cover.2c3339fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/images/login-cover.jpg
// module id = 1465
// module chunks = 0